import React, { useRef } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const JsonImportExport = ({ open, title, data, onImport, onClose }) => {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';
  const fileRef = useRef();

  if (!open) return null;

  const handleExport = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${(title || 'data').toLowerCase().replace(/\s+/g, '-')}-export.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const parsed = JSON.parse(ev.target.result);
        if (!Array.isArray(parsed)) {
          alert('Invalid format: expected a JSON array.');
          return;
        }
        onImport(parsed);
      } catch {
        alert('Invalid JSON file.');
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className={`relative w-full max-w-sm p-6 rounded-xl shadow-xl ${dark ? 'bg-[#1A1A1A] border border-[#333]' : 'bg-white'}`}>
        <h3 className={`text-lg font-semibold mb-4 ${dark ? 'text-white' : 'text-gray-900'}`}>
          {title || 'Import / Export'}
        </h3>
        <div className="space-y-3">
          <button
            onClick={handleExport}
            className={`w-full px-4 py-2.5 rounded-lg text-sm font-medium border ${
              dark ? 'border-[#333] text-gray-300 hover:bg-[#333]' : 'border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            Export JSON ({data?.length || 0} items)
          </button>
          <input
            ref={fileRef}
            type="file"
            accept=".json"
            className="hidden"
            onChange={handleImport}
          />
          <button
            onClick={() => fileRef.current?.click()}
            className={`w-full px-4 py-2.5 rounded-lg text-sm font-medium border ${
              dark ? 'border-[#333] text-gray-300 hover:bg-[#333]' : 'border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            Import from JSON file
          </button>
          <button
            onClick={onClose}
            className={`w-full px-4 py-2 rounded-lg text-sm ${dark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'}`}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JsonImportExport;
